$(function () {

    if ($('button#WithdrawButton').length > 0) {

        $("#WithdrawButton").on('click', function (e) {

            e.stopPropagation();
            e.preventDefault();

            $("#confirmModal").modal({
                'backdrop': 'static'
            });

            return false;
        });

        $("#btnConfirmWithdraw").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $("#btnConfirmWithdraw").prop("disabled", true);

            var url = '';

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/WageEnhancement/EmployeeDetails/WithdrawConditional/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/WageEnhancement/EmployeeDetails/WithdrawConditional/';
            }

            $.ajax({
                url: url + jsOper + '/' + jsAppId,
                method: 'POST',
                success: function (res) {
                    url = url.replace('/WithdrawConditional', '/Upload') + jsOper + '/' + jsEmployeeId;
                    window.location.href = url;
                },
                error: function (e) {
                    url = url.replace('EmployeeDetails/WithdrawConditional', 'Employee/Registered') + jsOper + '/' + jsEmployeeId;
                    window.location.href = url;
                }
            });

            return false;
        });
    }

    if ($('form#UploadForm').length > 0) {

        $("input[name='CanClaim05Hours']").change(function () {
            var val = $("input[name='CanClaim05Hours']:checked").val();

            if (val == jsTrueString) {
                $("#TrainingCompletedTypeDiv").removeClass("d-none")
            } else {
                $("#TrainingCompletedTypeDiv").addClass("d-none")
            }
        });

        $("input[name='CanClaim05Hours']").change();

        $("#RequestedFundingLevelTypeCd").change(function () {
            $(".funding-level-section").addClass("d-none");

            var id = $(this).val();

            var options = $("option.funding-level-option");;

            var optionCount = 0;
            var firstOption = -1;

            // Hide all the step options not available for the current funding level.
            options.each(function () {
                if ($(this).val() == jsOtherCd) {
                    return;
                }

                if ($(this).attr("data-type") == id) {
                    $(this).removeClass("d-none");

                    // The first option we find will be selected by default
                    // if only one option is available.
                    if (firstOption < 0) {
                        firstOption = $(this).val();
                    }

                    optionCount++;
                } else {
                    $(this).addClass("d-none");
                }
            });

            // If there's more than one option available (Minus the blank) we don't show the dropdown.
            // The only option will be selected by default.
            if (optionCount > 1) {
                $("#RequestedFundingLevelId").val(jsOtherCd);
                $(".funding-level-section").removeClass("d-none");
            } else {
                $("#RequestedFundingLevelId").val(firstOption);
            }

            // If untrained relief staff is selected, we need to do update some parts of the screen
            if (id == jsOtherCd) {
                $(".trained-only").each(function () {
                    $(this).addClass("d-none");
                });
            } else if (id == jsUntrainedReliefStaffCd) {
                $(".trained-only").each(function () {
                    $(this).addClass("d-none");
                });
            } else {
                $(".trained-only").each(function () {
                    $(this).removeClass("d-none");
                });

                $("input[name='CanClaim05Hours']").first().change();

                if (id == jsEntryLevelCd) {
                    $(".hours-span").text(90);
                } else {
                    $(".hours-span").text(30);
                }
            }
        });

        $("#RequestedFundingLevelTypeCd").change();
    } // if ($('form#UploadForm').length > 0)
}); // $(function () {